import { createSlice } from '@reduxjs/toolkit'

const orderSummarySlice = createSlice({
    name: 'orderSummary',
    initialState: {
        error: null,
        loading: false,
        disable: false,
        booking: null,
        payment: null,
        goPayVariant: 'Card',
    },
    reducers: {
        setLoading(state, action) {
            const { payload } = action

            state.loading = payload
        },
        setDisable(state, action) {
            const { payload } = action

            state.disable = payload
        },
        setError(state, action) {
            const { payload } = action

            if (!payload) {
                return { ...state, error: null }
            }

            return { ...state, error: payload }
        },
        setBookingData(state, action) {
            const { payload } = action

            if (!payload) {
                return state
            }

            return { ...state, booking: payload }
        },
        setPaymentData(state, action) {
            const { payload } = action

            if (!payload) {
                return state
            }

            return { ...state, payment: payload }
        },
        setGoPayVariant(state, action) {
            const { payload } = action
            state.goPayVariant = payload
        },
        setPayment() {},
        paymentStart() {},
        reservationStart() {},
        payTicketWithPoints() {},
        payTicketWithMoney() {},
        qrLoaded() {},
    },
})

const { actions, reducer } = orderSummarySlice

export const {
    setLoading,
    setDisable,
    setError,
    setPayment,
    setBookingData,
    setPaymentData,
    paymentStart,
    reservationStart,
    payTicketWithPoints,
    payTicketWithMoney,
    qrLoaded,
    setGoPayVariant,
} = actions

export default reducer
